<div class="overly" (click)="closeModal()" *ngIf="modalControl?.showModal">
    <div class="popup-scroll-area">
        <div class="modal" (click)="$event.stopPropagation()">
            <header class="header">
                <div class="close-button" (click)="closeModal()">
                    <i class="ju ju-close"></i>
                </div>
                <span class="title">Liegenschaft</span>
            </header>

            <div class="modal-content">
                <div class="data-content">
                    <div class="card">
                        <div class="card-content" *ngIf="!editMode">
                            <div class="sensor-row">
                                <div class="label">Kunde:</div>
                                <div class="value">
                                    {{ site.customerName || '-' }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Adresse:</div>
                                <div class="value">
                                    <a [href]="getGoogleMapsLink()" target="_blank">
                                        {{ site.street + ' ' + site.streetNumber + ', ' + site.postCode + ' ' + site.city + (site.additionalName ? ' - ' + site.additionalName : '') }}
                                    </a>
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Seriennummer:</div>
                                <div class="value">
                                    {{ site.serialNumbers.join(', ') || '-' }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Salesforce ID:</div>
                                <div class="value">
                                    {{ site.salesforceId || '-' }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Ansprechpartner:</div>
                                <div class="value">
                                    {{ site.contactPersonName || '-' }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Ansprechpartner Nr:</div>
                                <div class="value">
                                    {{ site.contactPersonNumber || '-' }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Steuerung beauftragt:</div>
                                <div class="value">
                                    {{ site.installedControl ? 'Ja' : 'Nein' }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Servicetechniker:</div>
                                <div class="value">
                                    {{ site.installationPersonEmail || '-' }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Geplante KW:</div>
                                <div class="value">
                                    {{ site.installationWeek || '-' }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Notizen:</div>
                                <div class="value">
                                    {{ site.note || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="card-content" *ngIf="editMode">
                            <div class="sensor-row">
                                <div class="label">Kunde:</div>
                                <div class="value">
                                    {{ editSite.customerName || '-' }}
                                </div>
                            </div>
                            <div class="address">
                                <div class="address-title">Adresse:</div>
                                <div class="sensor-row">
                                    <div class="label">Straße*:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="editSite.street" required
                                               (ngModelChange)="editStreet($event)">
                                    </div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Hausnummer*:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="editSite.streetNumber" required
                                               (ngModelChange)="editStreetNumber($event)">
                                    </div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Postleitzahl*:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="editSite.postCode" required pattern="^\d{5}$"
                                               (ngModelChange)="editPostCode($event)">
                                    </div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Stadt*:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="editSite.city" required
                                               (ngModelChange)="editCity($event)">
                                    </div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Latitude:</div>
                                    <div class="value">
                                        <input [disabled]="!editSite.coordinatesAddedManually" type="text"
                                               [ngModel]="editSite.latitude"
                                               (ngModelChange)="editLatitude($event)">
                                    </div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Longitude:</div>
                                    <div class="value">
                                        <input [disabled]="!editSite.coordinatesAddedManually" type="text"
                                               [ngModel]="editSite.longitude"
                                               (ngModelChange)="editLongitude($event)">
                                    </div>
                                </div>
                                <div class="sensor-row checkbox">
                                    <input type="checkbox" [(ngModel)]="editSite.coordinatesAddedManually">
                                    <div class="label">Koordinaten manuell eingegeben</div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Zusatzname:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="editSite.additionalName"
                                               (ngModelChange)="editAdditionalName($event)">
                                    </div>
                                </div>
                                <div class="sensor-row">
                                    <div class="label">Salesforce ID:</div>
                                    <div class="value">
                                        <input type="text" [ngModel]="editSite.salesforceId"
                                               (ngModelChange)="editSalesforceId($event)">
                                    </div>
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Ansprechpartner:</div>
                                <div class="value">
                                    <input type="text" [ngModel]="editSite.contactPersonName"
                                           (ngModelChange)="editContactPersonName($event)">
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Ansprechpartner Nr:</div>
                                <div class="value">
                                    <input type="text" [ngModel]="editSite.contactPersonNumber"
                                           (ngModelChange)="editContactPersonNumber($event)">
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Servicetechniker:</div>
                                <div class="value">
                                    <ng-select name="installationPersonEmail" id="installationPersonEmail"
                                               [clearable]="true"
                                               [(ngModel)]="editSite.installationPersonEmail"
                                               (ngModelChange)="editInstallationPersonEmail($event)">
                                        <ng-option *ngFor="let serviceTechnician of serviceTechnicians"
                                                   [value]="serviceTechnician.email">
                                            {{ serviceTechnician.email }}
                                        </ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Geplante KW:</div>
                                <div class="value">
                                    <input type="number" [ngModel]="editSite.installationWeek" pattern="^\d{1,2}$"
                                           [min]="1" [max]="53"
                                           (ngModelChange)="editInstallationWeek($event)">
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="label">Notizen:</div>
                                <div class="value">
                                    <textarea [ngModel]="editSite.note"
                                              (ngModelChange)="editNotes($event)">
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="popup-footer">
                <button *ngIf="isPlanner && !editMode" class="primary" [disabled]="!canEdit()"
                        (click)="movePin()">Koordinaten ändern
                </button>
            </div>

            <div class="popup-footer">
                <button *ngIf="isPlanner && !editMode" class="primary" [disabled]="!canEdit()"
                        (click)="enableEditMode()">Bearbeiten
                </button>
            </div>

            <div class="popup-footer">
                <button *ngIf="isPlanner && editMode" class="primary" [disabled]="!canSaveSite()" (click)="saveSite()">
                    Speichern
                </button>
            </div>

            <div class="popup-footer">
                <button *ngIf="isPlanner && editMode" class="secondary" [disabled]="!canEdit()"
                        (click)="disableEditMode()">Abbrechen
                </button>
            </div>
        </div>
    </div>
</div>
